import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Section from '../Section';
import Details from './Details';
import { joinPath } from 'utils/path';
function WorkExperience({ className, editPath, indexedMeta, language, workExperience }) {
  const location = useLocation();

  const path = useMemo(() => {
    return editPath ? joinPath(editPath, 'work-experience') : '';
  }, [editPath]);

  const addPathState = useMemo(() => ({ background: location }), [location]);

  const [expanded, setExpanded] = useState(false);

  function handleToggle() {
    setExpanded(expanded => !expanded);
  }

  return (
    <Section
      addPath={path}
      addPathState={addPathState}
      className={className}
      handleCollapseExpand={handleToggle}
      isExpanded={expanded}
      showExpandCollapse={true}
      title="title.workExperience"
    >
      {/* Boolean conversion needed to avoid displaying "0" when length is 0 */}
      {!!workExperience.length && (
        <Details
          editPath={path}
          expandCollapse={expanded}
          handleCollapseExpand={handleToggle}
          indexedMeta={indexedMeta}
          language={language}
          workExperience={workExperience}
        />
      )}
    </Section>
  );
}

WorkExperience.propTypes = {
  className: PropTypes.string,
  editPath: PropTypes.string,
  indexedMeta: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  workExperience: PropTypes.array
};

export default WorkExperience;
